module.exports = __webpack_public_path__ + "static/knowledge-and-decisions-45d2bf573a88e9025f35456a3a04586d.jpg";